var _excluded = ["analyticsName", "onClick", "leftIcon", "rightIcon", "disabled", "href", "children"];

function cov_10uyfywcnq() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Link/Link.tsx";
  var hash = "7e164dd1607c705baa1d22e2a366da6892461fc4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Link/Link.tsx",
    statementMap: {
      "0": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 116,
          column: 1
        }
      },
      "1": {
        start: {
          line: 32,
          column: 21
        },
        end: {
          line: 32,
          column: 95
        }
      },
      "2": {
        start: {
          line: 33,
          column: 19
        },
        end: {
          line: 36,
          column: 6
        }
      },
      "3": {
        start: {
          line: 37,
          column: 31
        },
        end: {
          line: 37,
          column: 53
        }
      },
      "4": {
        start: {
          line: 39,
          column: 32
        },
        end: {
          line: 44,
          column: 6
        }
      },
      "5": {
        start: {
          line: 45,
          column: 23
        },
        end: {
          line: 45,
          column: 51
        }
      },
      "6": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 54,
          column: 32
        }
      },
      "7": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 52,
          column: 7
        }
      },
      "8": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 51,
          column: 73
        }
      },
      "9": {
        start: {
          line: 56,
          column: 24
        },
        end: {
          line: 65,
          column: 5
        }
      },
      "10": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 58,
          column: 91
        }
      },
      "11": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 61,
          column: 9
        }
      },
      "12": {
        start: {
          line: 60,
          column: 10
        },
        end: {
          line: 60,
          column: 21
        }
      },
      "13": {
        start: {
          line: 67,
          column: 25
        },
        end: {
          line: 71,
          column: 5
        }
      },
      "14": {
        start: {
          line: 68,
          column: 12
        },
        end: {
          line: 68,
          column: 94
        }
      },
      "15": {
        start: {
          line: 73,
          column: 42
        },
        end: {
          line: 86,
          column: 5
        }
      },
      "16": {
        start: {
          line: 88,
          column: 42
        },
        end: {
          line: 92,
          column: 5
        }
      },
      "17": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 108,
          column: 5
        }
      },
      "18": {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 107,
          column: 8
        }
      },
      "19": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 114,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        },
        loc: {
          start: {
            line: 31,
            column: 96
          },
          end: {
            line: 115,
            column: 3
          }
        },
        line: 31
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 49,
            column: 14
          },
          end: {
            line: 49,
            column: 15
          }
        },
        loc: {
          start: {
            line: 49,
            column: 20
          },
          end: {
            line: 54,
            column: 5
          }
        },
        line: 49
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 57,
            column: 7
          }
        },
        loc: {
          start: {
            line: 57,
            column: 13
          },
          end: {
            line: 62,
            column: 7
          }
        },
        line: 57
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 68,
            column: 7
          }
        },
        loc: {
          start: {
            line: 68,
            column: 12
          },
          end: {
            line: 68,
            column: 94
          }
        },
        line: 68
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 32,
            column: 21
          },
          end: {
            line: 32,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 21
          },
          end: {
            line: 32,
            column: 55
          }
        }, {
          start: {
            line: 32,
            column: 59
          },
          end: {
            line: 32,
            column: 95
          }
        }],
        line: 32
      },
      "1": {
        loc: {
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 52,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 52,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 50
      },
      "2": {
        loc: {
          start: {
            line: 50,
            column: 10
          },
          end: {
            line: 50,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 10
          },
          end: {
            line: 50,
            column: 16
          }
        }, {
          start: {
            line: 50,
            column: 20
          },
          end: {
            line: 50,
            column: 33
          }
        }],
        line: 50
      },
      "3": {
        loc: {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 58,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 58,
            column: 21
          }
        }, {
          start: {
            line: 58,
            column: 25
          },
          end: {
            line: 58,
            column: 90
          }
        }],
        line: 58
      },
      "4": {
        loc: {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 59
      },
      "5": {
        loc: {
          start: {
            line: 59,
            column: 12
          },
          end: {
            line: 59,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 12
          },
          end: {
            line: 59,
            column: 19
          }
        }, {
          start: {
            line: 59,
            column: 23
          },
          end: {
            line: 59,
            column: 32
          }
        }],
        line: 59
      },
      "6": {
        loc: {
          start: {
            line: 68,
            column: 12
          },
          end: {
            line: 68,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 68,
            column: 12
          },
          end: {
            line: 68,
            column: 25
          }
        }, {
          start: {
            line: 68,
            column: 29
          },
          end: {
            line: 68,
            column: 94
          }
        }],
        line: 68
      },
      "7": {
        loc: {
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 80,
            column: 40
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 80,
            column: 23
          },
          end: {
            line: 80,
            column: 31
          }
        }, {
          start: {
            line: 80,
            column: 34
          },
          end: {
            line: 80,
            column: 40
          }
        }],
        line: 80
      },
      "8": {
        loc: {
          start: {
            line: 84,
            column: 12
          },
          end: {
            line: 84,
            column: 39
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 84,
            column: 23
          },
          end: {
            line: 84,
            column: 32
          }
        }, {
          start: {
            line: 84,
            column: 35
          },
          end: {
            line: 84,
            column: 39
          }
        }],
        line: 84
      },
      "9": {
        loc: {
          start: {
            line: 90,
            column: 13
          },
          end: {
            line: 90,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 90,
            column: 13
          },
          end: {
            line: 90,
            column: 28
          }
        }, {
          start: {
            line: 90,
            column: 33
          },
          end: {
            line: 90,
            column: 72
          }
        }],
        line: 90
      },
      "10": {
        loc: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 108,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 108,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 94
      },
      "11": {
        loc: {
          start: {
            line: 98,
            column: 13
          },
          end: {
            line: 98,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 98,
            column: 13
          },
          end: {
            line: 98,
            column: 21
          }
        }, {
          start: {
            line: 98,
            column: 25
          },
          end: {
            line: 98,
            column: 62
          }
        }],
        line: 98
      },
      "12": {
        loc: {
          start: {
            line: 101,
            column: 11
          },
          end: {
            line: 105,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 102,
            column: 12
          },
          end: {
            line: 102,
            column: 50
          }
        }, {
          start: {
            line: 104,
            column: 12
          },
          end: {
            line: 104,
            column: 56
          }
        }],
        line: 101
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7e164dd1607c705baa1d22e2a366da6892461fc4"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_10uyfywcnq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_10uyfywcnq();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useMergeRefs } from '@chakra-ui/hooks';
import { forwardRef } from '@chakra-ui/system';
import { bricks } from '../../system/bricks.types';
import { useMultiStyleConfig } from '../../system/utils';
import { useObservabilitySafe } from '../../hooks/useObservabilitySafe';
import { Icon } from '../Icon';
import Flex from '../Flex';
export var Link = (cov_10uyfywcnq().s[0]++, forwardRef(function (_ref, ref) {
  var analyticsName = _ref.analyticsName,
      onClick = _ref.onClick,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      disabled = _ref.disabled,
      href = _ref.href,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_10uyfywcnq().f[0]++;
  var isButton = (cov_10uyfywcnq().s[1]++, (cov_10uyfywcnq().b[0][0]++, props.variant === 'primary-button') || (cov_10uyfywcnq().b[0][1]++, props.variant === 'secondary-button'));
  var styles = (cov_10uyfywcnq().s[2]++, useMultiStyleConfig('Link', _objectSpread(_objectSpread({}, props), {}, {
    disabled: disabled
  })));

  var _ref2 = (cov_10uyfywcnq().s[3]++, useObservabilitySafe()),
      trackUserEvent = _ref2.trackUserEvent;

  var _ref3 = (cov_10uyfywcnq().s[4]++, useInView({
    // number between 0 and 1 indicates the percentage that should be visible before triggering. (set at 100% for now)
    threshold: 1,
    // only create the intersection observer if a non-empty `analyticsName` is passed in
    skip: !analyticsName
  })),
      _ref4 = _slicedToArray(_ref3, 2),
      inViewRef = _ref4[0],
      inView = _ref4[1];

  var mergedRefs = (cov_10uyfywcnq().s[5]++, useMergeRefs(inViewRef, ref)); // In other components (like Box), we only attach the inView handler if analyticsName
  // is defined. In this one, analyticsName is required, so we always attach.

  cov_10uyfywcnq().s[6]++;
  useEffect(function () {
    cov_10uyfywcnq().f[1]++;
    cov_10uyfywcnq().s[7]++;

    if ((cov_10uyfywcnq().b[2][0]++, inView) && (cov_10uyfywcnq().b[2][1]++, analyticsName)) {
      cov_10uyfywcnq().b[1][0]++;
      cov_10uyfywcnq().s[8]++;
      trackUserEvent({
        linkViewEvent: {
          targetName: analyticsName
        }
      });
    } else {
      cov_10uyfywcnq().b[1][1]++;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [inView, analyticsName]);
  var handleClick = (cov_10uyfywcnq().s[9]++, useCallback(function (e) {
    cov_10uyfywcnq().f[2]++;
    cov_10uyfywcnq().s[10]++;
    (cov_10uyfywcnq().b[3][0]++, analyticsName) && (cov_10uyfywcnq().b[3][1]++, trackUserEvent({
      linkClickEvent: {
        targetName: analyticsName
      }
    }));
    cov_10uyfywcnq().s[11]++;

    if ((cov_10uyfywcnq().b[5][0]++, onClick) && (cov_10uyfywcnq().b[5][1]++, !disabled)) {
      cov_10uyfywcnq().b[4][0]++;
      cov_10uyfywcnq().s[12]++;
      onClick(e);
    } else {
      cov_10uyfywcnq().b[4][1]++;
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [analyticsName, onClick, disabled]));
  var onMouseEnter = (cov_10uyfywcnq().s[13]++, useCallback(function () {
    cov_10uyfywcnq().f[3]++;
    cov_10uyfywcnq().s[14]++;
    return (cov_10uyfywcnq().b[6][0]++, analyticsName) && (cov_10uyfywcnq().b[6][1]++, trackUserEvent({
      linkHoverEvent: {
        targetName: analyticsName
      }
    }));
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [analyticsName]));
  var linkProps = (cov_10uyfywcnq().s[15]++, _objectSpread({
    /*
     * NOTE: Forcing links to function as buttons to ensure that a11y is handled correctly
     * This is a known antipattern, however for conversion reasons this is occasionally a
     * requirement. Make sure to verify with design that this behavior is absolutely necessary
     * and appropriate a11y concerns were considered.
     */
    role: isButton ? (cov_10uyfywcnq().b[7][0]++, 'button') : (cov_10uyfywcnq().b[7][1]++, 'link'),
    __css: styles.link,
    onClick: handleClick,
    onMouseEnter: onMouseEnter,
    href: disabled ? (cov_10uyfywcnq().b[8][0]++, undefined) : (cov_10uyfywcnq().b[8][1]++, href)
  }, props));
  var iconProps = (cov_10uyfywcnq().s[16]++, {
    __css: styles.icon,
    color: (cov_10uyfywcnq().b[9][0]++, linkProps.color) || (cov_10uyfywcnq().b[9][1]++, styles.link.color),
    size: 16
  });
  cov_10uyfywcnq().s[17]++;

  if (props.variant === 'nav') {
    cov_10uyfywcnq().b[10][0]++;
    cov_10uyfywcnq().s[18]++;
    return /*#__PURE__*/React.createElement(bricks.a, _extends({
      ref: mergedRefs
    }, linkProps), /*#__PURE__*/React.createElement(Flex, {
      __css: styles.content
    }, (cov_10uyfywcnq().b[11][0]++, leftIcon) && (cov_10uyfywcnq().b[11][1]++, /*#__PURE__*/React.createElement(Icon, _extends({}, iconProps, leftIcon))), children), rightIcon ? (cov_10uyfywcnq().b[12][0]++, /*#__PURE__*/React.createElement(Icon, _extends({}, iconProps, rightIcon))) : (cov_10uyfywcnq().b[12][1]++, /*#__PURE__*/React.createElement(Icon, _extends({}, iconProps, {
      name: "chevron-right"
    }))));
  } else {
    cov_10uyfywcnq().b[10][1]++;
  }

  cov_10uyfywcnq().s[19]++;
  return /*#__PURE__*/React.createElement(bricks.a, _extends({
    ref: mergedRefs
  }, linkProps), children);
}));
export default Link;